// src/App.jsx
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "./components/common/ScrollToTop";
import Router from "./routes/router";
import { useAppDispatch } from "./hooks/useDispatch";
import { fetchPublicCourses } from "./reducers/courses/courseSlice";
import { useAppSelector } from "./hooks/useAppSelector";
import { QueryParams } from "./reducers/courses/courseTypes";

function App() {
  const dispatch = useAppDispatch();
  const { lastFetched } = useAppSelector((state) => state.courses);
  const cacheKey = `page:${1}|limit:10|teacherId:1`;
  const isCacheValid =
    lastFetched[cacheKey] && Date.now() - lastFetched[cacheKey] < 5 * 60 * 1000; // 5 minutes

  useEffect(() => {
    const fetchData = async () => {
      const queryParams: QueryParams = {
        page: 1,
        limit: 10,
        isPublished: true,
      };

      if (!isCacheValid) {
        try {
          await dispatch(fetchPublicCourses(queryParams)).unwrap();
        } catch (error) {
          console.error("Failed to fetch courses");
        }
      }
    };

    fetchData();
  }, [dispatch, isCacheValid]);

  return (
    <BrowserRouter>
      <ScrollToTop
        smooth={true}
        scrollDelay={100}
        excludePaths={["/no-scroll"]}
        // onScrollComplete={() => console.log("Scroll complete")}
      />
      <Toaster
        position="top-center"
        expand={true}
        richColors={true}
        closeButton={true}
        duration={4000}
        theme="dark" // 'light', 'dark', or 'system'
      />
      <Router />
    </BrowserRouter>
  );
}

export default App;
